import Vue from 'vue'
import VueI18n from 'vue-i18n'
import config from '../config'
import EN from './en'
import FI from './fi'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: config.baseLanguage,
  fallbackLocale: config.baseLanguage,
  messages: {
    EN,
    FI
  }
})
